import LatestInsights from './LatestInsights'

export default LatestInsights
